// Scraper.jsx
import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import { GoSearch } from 'react-icons/go';
import {client, urlFor } from '../sanity/sanityClient';
import writer from '../assets/writer.svg';

export default function Scraper({ onSelectedProduct, categories, isLoading, isTrader, traderProducts }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchMode, setSearchMode] = useState("name"); // "name" | "location"

  useEffect(() => {
  if (!searchQuery.trim()) {
    setSearchResults([]);
    setSearching(false);
    return;
  }

  const debounce = setTimeout(async () => {
    try {
      let query;

      // 🔍 NAME SEARCH → ranked
      if (searchMode === "name") {
        query = `*[
          _type in [
            "clothingandfashion","electronics","arts","fashion","salon","grocery","beauty","crops",
            "servicesandinstitutions","energyandfuel","toys","sports","kitchen","hotels","hardware",
            "books","estate","foodandbeverages","agritech","giftoptions","cuisines","eventsandnightclubs",
            "homeandfurnitures","vehicles","jewelryandaccessories","medical","useditems","construction",
            "kidsandtoys","hospitality","booksandstationery"
          ]
        ]
        | score(name match $search)
        | order(_score desc)
        [0...40]`;
      }

      // 🌍 LOCATION SEARCH → strict (no scoring)
      if (searchMode === "location") {
        query = `*[
          _type in [
            "clothingandfashion","electronics","arts","fashion","salon","grocery","beauty","crops",
            "servicesandinstitutions","energyandfuel","toys","sports","kitchen","hotels","hardware",
            "books","estate","foodandbeverages","agritech","giftoptions","cuisines","eventsandnightclubs",
            "homeandfurnitures","vehicles","jewelryandaccessories","medical","useditems","construction",
            "kidsandtoys","hospitality","booksandstationery"
          ]
          && lower(location) match lower($search)
        ][0...40]`;
      }

      const results = await client.fetch(query, {
        search: `*${searchQuery}*`,
      });

      setSearchResults(results);
      setSearching(true);

    } catch (error) {
      console.error("Search error:", error);
    }
  }, 400); // debounce

  return () => clearTimeout(debounce);
}, [searchQuery, searchMode]);


  const handleProductClick = (product) => {
    onSelectedProduct(product.image[0].asset._ref);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };


  return (
    <div
  className="market"
  style={{
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100vh",
  }}
>

      <div className="upper-div">
        <p style={{ display:'flex', flexDirection:'row', justifyContent:'center', color:'blue', margin: "0" }}> Mpesa: 58450600 </p>
        <p style={{ display:'flex', flexDirection:'row', justifyContent:'center', color:'blue', margin: "0" }}> Lipa Bridgenapp </p>
        <div className="search-form" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '90%', borderRadius: '10px', backgroundColor: '#f0f0f0', border: 'solid', position: 'relative' }}>
          <div><GoSearch /></div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            required
            placeholder={'Search'}
            style={{ width: '90%', height: '20px', borderRadius: '5px', border: 'none', outline: 'none' }}
          /><select
                value={searchMode}
                onChange={(e) => setSearchMode(e.target.value)}
                style={{
                  height: '24px',
                  marginLeft: '5px',
                  borderRadius: '5px',
                  border: 'none',
                  fontSize: '12px'
                }}
              >
                <option value="name">By Name</option>
                <option value="location">By Location</option>
              </select>
          {searchQuery && (
            <button 
              onClick={clearSearch}
              style={{
                position: 'absolute',
                right: '10px',
                background: 'transparent',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ×
            </button>
          )}
        </div>
      </div>
      
      <div className="search-results-two" >
        {searching && searchResults.length > 0 ? (
          // Display search results immediately inside search-results-two
          searchResults.map((product) => (
            <div key={product._id} className="result-item">
              {product.soldout ? <span style={{ position: 'absolute', top: 5, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', color: 'red', padding: '5px', borderRadius: '5px' }}>{product.soldout}</span> : ''}
              {product.discount ? <span style={{ position: 'absolute', top: 5, left: 230, whiteSpace: 'nowrap', backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', padding: '5px', borderRadius: '5px' }}>{product.discount}</span> : ''}
              <img
                src={urlFor(product.image[0])}
                product={urlFor(product.image[0])}
                alt={product.name}
                onClick={() => handleProductClick(product)}
              />
              <div className="result-display">
                <p style={{ fontSize: 'small', color: 'red' }}>{product.currency || 'TZS'}: <strong>{product.price.toLocaleString()}/=</strong></p>
              </div>
            </div>
          ))
        ) : isLoading && categories.length <= 0 ? (
          <Loader />
        ) : !isLoading && categories.length <= 0 ? (
          <div className='displayCenter' style={{ textAlign: 'center' }}>
            <img src={writer} width={300} height={300} alt="no-internet" />
            <h5>No products</h5>
            <p style={{ display: 'flex' }}>Check another category or trader</p>
          </div>
        ) : (isTrader ? (
          traderProducts.map((product) => (
            <div key={product._id} className="result-item">
              {product.soldout ? <span style={{ position: 'absolute', top: 5, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', color: 'red', padding: '5px', borderRadius: '5px' }}>{product.soldout}</span> : ''}
              {product.discount ? <span style={{ position: 'absolute', top: 5, left: 230, whiteSpace: 'nowrap', backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', padding: '5px', borderRadius: '5px' }}>{product.discount}</span> : ''}
              <img
                src={urlFor(product.image[0])}
                product={urlFor(product.image[0])}
                alt={product.name}
                onClick={() => handleProductClick(product)}
              />
              <div className="result-display">
                <p style={{ fontSize: 'small', color: 'red' }}>{product.currency || 'TZS'}:{product.price.toLocaleString()}/=</p>
              </div>
            </div>
          ))
        ) : (
          categories.map((product) => (
            <div key={product._id} className="result-item">
              {product.soldout ? <span style={{ position: 'absolute', top: 5, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', color: 'red', padding: '5px', borderRadius: '5px' }}>{product.soldout}</span> : ''}
              {product.discount ? <span style={{ position: 'absolute', top: 5, left: 230, whiteSpace: 'nowrap', backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', padding: '5px', borderRadius: '5px' }}>{product.discount}</span> : ''}
              <img
                src={urlFor(product.image[0])}
                product={urlFor(product.image[0])}
                alt={product.name}
                onClick={() => handleProductClick(product)}
              />
              <div className="result-display">
                <p style={{ fontSize: 'small', color: 'red' }}>{product.currency || 'TZS'}:{product.price.toLocaleString()}/=</p>
              </div>
            </div>
          )).reverse()
        ))}
      </div>
    </div>
  );
}